<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div style="margin:0 auto; text-align: center;">
		<div class="matTitulo">
			<i class="fal fa-file-search" id="ico"></i>
			<h1 class="titulo" style="display:inline-block;">Histórico de Posiciones</h1>
		</div>
		<mat-divider></mat-divider>
	</div>
</div>
<mat-card class="mt-2">
	<mat-card-content class="card-content">
		<div class="row">
			<div class="col-md-12">
				<h4>{{activo.descripcion}}</h4>
			</div>
			<div class="col-md-8">
				<span>Especifique un rango de tiempo en el cual desea obtener ubicaciones del activo
					seleccionado.</span>
			</div>
			<div class="col-md-4">
				<div class="row">
					<kt-boton-exportar-tabla [style]="{'margin-left': '1px'}" [tipoBoton]="'monitoreo'"
					[nombreArchivo]="'Historico_Posiciones_Activo'" [datos]="datosReporte"
					[buttonDisabled]="isDisabled">
					</kt-boton-exportar-tabla>
				</div>
			</div>
		</div>
		<mat-divider class="mt-3"></mat-divider><br>
		<dx-validation-group #targetGroup>
			<div class="row">
				<div class="col col-sm-12 col-md-12 col-lg-12">
					<div class="row mt-3">
						<div class="col col-sm-12 col-md-4 col-lg-4">
							<label>Fecha Inicial:</label>
							<dx-date-box [(value)]="fechaInicio" type="datetime" style="width: 100%;"
								displayFormat="yyyy-MM-dd HH:mm:ss">
								<dx-validator>
									<dxi-validation-rule message="Campo requerido" type="required">
									</dxi-validation-rule>
								</dx-validator>
							</dx-date-box>
						</div>
						<div class="col col-sm-12 col-md-4 col-lg-4">
							<label>Fecha Final:</label>
							<dx-date-box [(value)]="fechaFin" style="width: 100%;" type="datetime"
								displayFormat="yyyy-MM-dd HH:mm:ss">
								<dx-validator>
									<dxi-validation-rule message="Campo requerido" type="required">
									</dxi-validation-rule>
								</dx-validator>
							</dx-date-box>
						</div>
						<div class="col col-sm-12 col-md-4 col-lg-4 mt-3">
							<div class="row mt-3">
								<button id="boton" type="submit" class="btn btn-success"
									(click)="obtenerReportePosiciones(fechaInicio, fechaFin)"><i
										class="fal fa-search"></i>Buscar</button>&nbsp;
								<button id="botonAlDia" type="submit" class="btn btn-success"
										(click)="reporteAlDia()"><i class="fal fa-clock"></i>Al
									día</button>&nbsp;
							</div>
						</div>
					</div>
				</div>
			</div>
		</dx-validation-group>
		<mat-divider *ngIf="showTable" class="mt-4"></mat-divider>
		<div class="grid">
			<dx-data-grid *ngIf="showTable" id="gridContainer" [rowAlternationEnabled]="true"
				[columnHidingEnabled]="true" [dataSource]="reportePos" [showBorders]="true">
				<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
				<dxo-paging [pageSize]="5"></dxo-paging>
				<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 25, 50, 100]" [showInfo]="true">
				</dxo-pager>
				<dxi-column caption="Acciones" alignment="center" cellTemplate="Abrir">
				</dxi-column>
				<dxi-column dataField="fechaHora" alignment="center" dataType="date" format="shortDateShortTime">
					<dxo-header-filter [dataSource]="orderHeaderFilter"></dxo-header-filter>
				</dxi-column>
				<dxi-column dataField="imei" alignment="center" caption="Imei"></dxi-column>
				<dxi-column dataField="descripcion" alignment="center" caption="Descripción"
					cellTemplate="cellDescripcion">
				</dxi-column>
				<dxi-column dataField="bateria" alignment="center" caption="Batería" cellTemplate="cellBateria">
				</dxi-column>
				<dxi-column dataField="alimentacion" alignment="center" caption="Alimentación"
					cellTemplate="cellAlimentacion">
				</dxi-column>
				<dxi-column dataField="movimiento" alignment="center" caption="Movimiento"
					cellTemplate="cellMovimiento">
				</dxi-column>
				<dxi-column dataField="gps" alignment="center" caption="GPS" cellTemplate="cellGPS">
				</dxi-column>
				<dxi-column dataField="gsm" alignment="center" caption="GSM" cellTemplate="cellGSM">
				</dxi-column>
				<dxi-column dataField="lat" alignment="center" caption="Latitud"></dxi-column>
				<dxi-column dataField="lng" alignment="center" caption="Longitud"></dxi-column>
				<div *dxTemplate="let d of 'Abrir'" (click)="ubicarPuntoHistorico(d.data)" style="text-align: center;">
					<dx-button style="background-color: #fff;" class="btnAcciones">
						<i class="fa fa-eye" style="color:#166BA2"></i>
					</dx-button>
				</div>
				<div *dxTemplate="let descripcion of 'cellDescripcion'">
					<div *ngIf="descripcion.value != null">{{descripcion.value}}</div>
					<div *ngIf="descripcion.value == null">Sin datos</div>
				</div>
				<div *dxTemplate="let bateria of 'cellBateria'">
					<div *ngIf="bateria.value != null">{{bateria.value}}</div>
					<div *ngIf="bateria.value == null">Sin datos</div>
				</div>
				<div *dxTemplate="let celltemplate of 'cellAlimentacion'">
					<span class="{{celltemplate.data.color}}" >{{ celltemplate.data.alimentacion }}</span>
				</div>
				<div *dxTemplate="let movimiento of 'cellMovimiento'">
					<span *ngIf="movimiento.value === 'En Movimiento'" class="verde">{{movimiento.value}}
					</span>
					<span *ngIf="movimiento.value === 'Sin Movimiento'" class="gris">{{movimiento.value}}
					</span>
					<span *ngIf="movimiento.value == null">Sin datos</span>
				</div>
				<div *dxTemplate="let gps of 'cellGPS'">
					<span *ngIf="gps.value === 'Buena'" class="verde">{{gps.value}}</span>
					<span *ngIf="gps.value === 'Media'" class="naranja">{{gps.value}}</span>
					<span *ngIf="gps.value === 'Mala'" class="rojo">{{gps.value}}</span>
					<span *ngIf="gps.value == null">Sin datos</span>
				</div>
				<div *dxTemplate="let gsm of 'cellGSM'">
					<span *ngIf="gsm.value != null">{{gsm.value}}</span>
					<span *ngIf="gsm.value == null">Sin datos</span>
				</div>
			</dx-data-grid>
		</div>
	</mat-card-content>
</mat-card>


<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
	[showPane]="true" [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>
